export default "__VITE_ASSET__cL6ntCie__"